import React from "react";
import { Label, Button } from "components/bootstrap";
import { RelativeTime, Icon } from "components/common";
import IndexSizeSummary from "components/indices/IndexSizeSummary";
class IndexSummary extends React.Component {
  constructor(props) {
    super(props);
    this._formatLabels = (index) => {
      const labels = [];
      if (index.is_deflector) {
        labels.push(
          /* @__PURE__ */ React.createElement(Label, { key: `${this.props.name}-deflector-label`, bsStyle: "primary" }, "active write index")
        );
      }
      if (index.is_closed) {
        labels.push(
          /* @__PURE__ */ React.createElement(Label, { key: `${this.props.name}-closed-label`, bsStyle: "warning" }, "closed")
        );
      }
      if (index.is_reopened) {
        labels.push(
          /* @__PURE__ */ React.createElement(Label, { key: `${this.props.name}-reopened-label`, bsStyle: "success" }, "reopened")
        );
      }
      return /* @__PURE__ */ React.createElement("span", { className: "index-label" }, labels);
    };
    this._formatIndexRange = () => {
      if (this.props.isDeflector) {
        return /* @__PURE__ */ React.createElement("span", null, "Contains messages up to ", /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: /* @__PURE__ */ new Date() }));
      }
      const sizes = this.props.index.size;
      if (sizes) {
        const count = sizes.events;
        const { deleted } = sizes;
        if (count === 0 || count - deleted === 0) {
          return "Index does not contain any messages.";
        }
      }
      if (!this.props.indexRange) {
        return "Time range of index is unknown, because index range is not available. Please recalculate index ranges manually.";
      }
      if (this.props.indexRange.begin === 0) {
        return /* @__PURE__ */ React.createElement("span", null, "Contains messages up to ", /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: this.props.indexRange.end }));
      }
      return /* @__PURE__ */ React.createElement("span", null, "Contains messages from ", /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: this.props.indexRange.begin }), " up to", " ", /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: this.props.indexRange.end }));
    };
    this._formatShowDetailsLink = () => {
      if (this.state.showDetails) {
        return /* @__PURE__ */ React.createElement("span", { className: "index-more-actions" }, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_drop_down" }), " Hide Details / Actions");
      }
      return /* @__PURE__ */ React.createElement("span", { className: "index-more-actions" }, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_right" }), " Show Details / Actions");
    };
    this._toggleShowDetails = (event) => {
      event.preventDefault();
      this.setState((prevState) => ({ showDetails: !prevState.showDetails }));
    };
    this.state = {
      showDetails: props.isDeflector
    };
  }
  render() {
    const { index } = this.props;
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("h2", null, this.props.name, " ", /* @__PURE__ */ React.createElement("small", null, this._formatLabels(index), " ", this._formatIndexRange(), " ", /* @__PURE__ */ React.createElement(IndexSizeSummary, { index }), /* @__PURE__ */ React.createElement(Button, { onClick: this._toggleShowDetails, bsStyle: "link" }, this._formatShowDetailsLink()))), /* @__PURE__ */ React.createElement("div", { className: "index-info-holder" }, this.state.showDetails && this.props.children));
  }
}
IndexSummary.defaultProps = {
  indexRange: void 0
};
export default IndexSummary;
